export default class PinSwitchService {
    key = 'pin-switch';
    storage;

    constructor() {
        this.storage = localStorage
            || sessionStorage
            || {
                getItem() {
                    return null;
                },
                setItem() {
                },
                removeItem() {
                }
            }
    }

    get() {
        return this.storage.getItem(this.key) || '';
    }

    set() {
        const randomString = (len) => {
            const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let randomString = '';
            for (let i = 0; i < len; i++) {
                const randomPoz = Math.floor(Math.random() * charSet.length);
                randomString += charSet.substring(randomPoz, randomPoz + 1);
            }
            return randomString;
        }
        this.storage.setItem(this.key, randomString(46));
    }

    remove() {
        this.storage.removeItem(this.key);
    }
}